import { TFunction } from '@lyearn/i18n';
// types
import { PostFragment } from '@/features/messages/graphql/fragments/generated/Post';

import { createMarkup } from '../helpers';

export const getAdaptedMarkup = (
  t: TFunction,
  message: PostFragment['message'],
  editedAt: PostFragment['editedAt'],
) => {
  let markup = createMarkup(message);

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = markup.__html;

  const images = tempDiv.getElementsByTagName('img');
  for (const img of images) {
    img.width = 700;
  }

  markup.__html = tempDiv.innerHTML;

  if (editedAt) {
    markup.__html += `<span class="body-long-02 text-text-placeholder">(${t(
      'Common:Message.edited',
    )})</span>`;
  }

  return markup;
};

export const isSingleEmoji = (messageHtmlString: string) => {
  const htmlNode = document.createElement('div');
  htmlNode.innerHTML = messageHtmlString;
  const emojiElements = htmlNode.getElementsByClassName('emoji');

  // single emoji gives text content length of 2
  if (htmlNode.textContent?.length === 2 && emojiElements.length === 1) {
    return true;
  }
  return false;
};
